import React from "react";

const SingleTransactions = () => {
  return <div>SingleTransactions</div>;
};

export default SingleTransactions;
